// extracted by mini-css-extract-plugin
export default {"templateOne":"P_cR","image":"P_cS","headerContainer":"P_cT","description":"P_cV","templateOneContainer":"P_cW","lottoUk49":"P_cX","lottoDesc":"P_cY","lottoTitle":"P_cZ","info":"P_C"};